import React, { Component, PropTypes } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import CheckboxProfile from '../componentKit/CheckboxProfile'
import Timer from '../componentKit/Timer'
import InputProfile from '../componentKit/InputProfile'
import SelectProgram from '../componentKit/SelectProgram'
import InputCountMask from '../componentKit/InputCountMask'
import SelectComponent from '../componentKit/SelectComponent'
import Insurance from '../profile/Insurance'
import cookie from 'react-cookie'
import moment from 'moment'
import { Link, browserHistory } from 'react-router'
import { api, domen } from '../../config.js'
import InputDayPicker from './InputDayPicker'
import { OKSDK } from './oksdk.js'
import MobileDayPicker from './MobileDayPicker'
import CSSModules from 'react-css-modules'
import styles from './submitValidationForm.css'
import ReactTooltip from 'react-tooltip'
import BodyParams from '../profile/BodyParams'
import Modal from 'boron/FadeModal'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import  fetchJsonp from 'fetch-jsonp'
import {social} from '../../utils/data'

const contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

const FB = window.FB


/**
 *  Компонент SubmitValidationForm.
 *  Используется для вывода формы на странице анкета
 *
 */
class SubmitValidationForm extends Component {

  /**
   * @memberof  SubmitValidationForm
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {object} propTypes.initialValues Заполненные параметры с сервера
   * @prop {bool} propTypes.isBabyFeeding Есть ли блок кормление грудью
   * @prop {object} propTypes.userInfo Данные пользователя
   * @prop {object} propTypes.prevSeasons Блок Программа текущего сезона
   *
   * */

  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    isBabyFeeding: PropTypes.bool,
    userInfo: PropTypes.object.isRequired,
    prevSeasons: PropTypes.array.isRequired
  }

  state = {
    item: 'one',
    workTeam: '',
    height: '',
    /**
     * @memberof  SubmitValidationForm
     * Показать блок с предыдущими сезонами
     * */
    programsShow: false
  }

  componentDidMount(){
    const select = document.querySelector('.heightSelect')
    const button = select.querySelector('button')
    const divs = select.querySelectorAll('div')
    divs[4].style.lineHeight = '43px'
    button.style.display = 'none'

    console.log('didMount')
    console.log(this.props)
    console.log(window.location.hash)
    const hash = window.location.hash
    const myRegexp = /access_token=(.*)/;
    const token = myRegexp.exec(hash);
    console.log('tokennnnn')
    console.log(token)
    if(token){
      this.fetchIn(token[1])
    }

    document.body.addEventListener('click', (e) => {
      if(this.state.programsShow){
        this.setState({ programsShow: false});
      }
    })
    function initGoolge() {
      window.gapi.load('auth2', () =>{
        window.gapi.auth2.init({
          client_id: social.gp.clientId,
          scope: 'profile'
        }).then((res, err) => {
          console.log('thenn')
         let auth2 = window.gapi.auth2.getAuthInstance()
          console.log(auth2)
          console.log(res)
          console.log(res.isSignedIn.get())
          console.log(res.currentUser.get())
          console.log(err)
        })
      });
    }
    initGoolge()
  }

  onclickVk(){
    window.VK.Auth.login(getit)
    let self = this
    function getit(response){
      console.log('ressss')
      console.log(response)
      if(response.session){
        window.VK.Api.call('users.get', {user_ids: response.session.user.id, fields: 'photo_200', v:5.73},(r) => {
          console.log(r.response)
          console.log('r.response')
          console.log(r)
          const photo = r.response[0].photo_200
          self.refs.avatar.src = photo
          const photoPayload = {
            authToken: cookie.load('token'),
            data: { photo }
          }
          self.updatePhoto(photoPayload)
          self.socialNetUserCreate(social.vk.id, response.session.user.id)
        });
      }

    }
  }

  fetchIn(token){
    console.log('token2222')
    console.log(token)
    console.log(social.in)
    const url = `https://api.instagram.com/v1/users/self/?access_token=${token}`
    let self = this
    fetchJsonp(url)
      .then(function(response) {
        return response.json()
      }).then(function(json) {
      console.log('jsonnnp')
      console.log(json)
      const photo = json.data.profile_picture
      self.refs.avatar.src = photo
      const photoPayload = {
        authToken: cookie.load('token'),
        data: { photo }
      }
      self.updatePhoto(photoPayload)
      self.socialNetUserCreate(social.in.id, json.data.id)
    }).catch(function(ex) {
        console.log(ex)
    })
  }

  onClickIn(){
    window.location = `https://api.instagram.com/oauth/authorize/?client_id=${social.in.clientId}&redirect_uri=https://lk.todayme.ru/profile&response_type=token`
  }

  onClickGoogle(){
    const auth2 = window.gapi.auth2.getAuthInstance()
    const options = {
      prompt: ''
    }
    auth2.signIn(options).then((res, err) => {
      if(err){
        console.log(err)
      }
      const basicProfile = res.getBasicProfile()
      const photo = basicProfile.getImageUrl()
      console.log('basicProfile')
      console.log(basicProfile)
      console.log(res)
      console.log(basicProfile.getId())
      this.refs.avatar.src = photo
      const photoPayload = {
        authToken: cookie.load('token'),
        data: { photo }
      }
      this.updatePhoto(photoPayload)
      this.socialNetUserCreate(social.gp.id, basicProfile.getId())

      /*res.profileObj = {
        googleId: basicProfile.getId(),
        imageUrl: basicProfile.getImageUrl(),
        email: basicProfile.getEmail(),
        name: basicProfile.getName(),
        givenName: basicProfile.getGivenName(),
        familyName: basicProfile.getFamilyName()
      }*/
    })
  }

  updatePhoto(photoPayload) {
    return fetch(`${api}/user/user-update`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(photoPayload)
    })
    .then(response => response.json())
    .then(json => {
      console.log('updatePhoto')
      console.log(json)
    })
  }

  socialNetUserCreate(socialNetType, userIdOrToken, soc){

    let payload = {
      authToken: cookie.load('token'),
      data: {
        socialNetType: socialNetType,
        userId: userIdOrToken,
        token: userIdOrToken
      }
    }
    if(soc === 'FB'){
      delete payload.data.userId
    }
    console.log('socialNetUserCreate')
    console.log(payload)
    return fetch(`${api}/user/socialNetUser-create`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(json => {
        console.log('socialNetUserCreate22')
        console.log(json)
      })
        //if (json && json.data) {
  }

  componentWillMount() {
    let { dispatch, profileData, injuriesEx} = this.props,
      { birthday, babyBirthday, babyCount, didSports, lastBabyFeedMonth, injuryItems, diseases, injuriesExist} = profileData


    if (window.mobilecheck()) {
      contentStyle.margin = '100px'
      contentStyle.width = '300px'
    }
    // const script = document.createElement("script")

    // script.type  = "text/javascript"
    // script.text = 'http://api.ok.ru/js/fapi5.js'
    // document.body.appendChild(script)
    dispatch({ type: 'IS_INJURIES', injuriesExist: injuriesExist})
    dispatch({ type: 'IS_SPORTS', didSports: didSports})
    dispatch({ type: 'DISEASES_SET', diseases: diseases })
    dispatch({ type: 'INJURIES_GET', items: injuryItems })
    dispatch({ type: 'INJURIES_HIDDEN', injuriesHidden: injuriesEx })
    dispatch({ type: 'IS_BABY_FEEDING', isBabyFeeding: profileData.isBabyFeeding })
    if(!babyCount){
      dispatch({ type: 'CHILDS_SET', value: 'zero' })
    } else {
      dispatch({ type: 'CHILDS_SET', value: babyCount })
    }

    if(babyBirthday){
      dispatch({ type: 'BABY_BIRTHDAY', babyBirthday: moment(babyBirthday).format('YYYY-MM-DD') })
    }
    if(lastBabyFeedMonth){
      dispatch({ type: 'LAST_BABY_FEED', lastBabyFeedMonth: moment(lastBabyFeedMonth).format('YYYY-MM-DD') })
    }
  }

  loadPhoto(input){
    const { target } = input
    if (target.files && target.files[0]) {
      var reader = new FileReader()

      reader.onload = e => {
        this.refs.avatar.src = e.target.result

        const payload = {
          authToken: cookie.load('token'),
          data: {
            name: target.files[0].name,
            content: reader.result.replace(/data:image\/\w+;base64,/, '')
          }
        }

        return fetch(`${api}/data/file-upload`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(payload)
        })
          .then(response => response.json())
          .then(json => {
            if (json.errorCode === 1 && json.data) {
              const photoPayload = {
                authToken: cookie.load('token'),
                data: {
                  photo: `${api}/files/${json.data.uid}.${json.data.extension}`.replace(/api\//, '')
                }
              }

              return this.updatePhoto(photoPayload)
            }
          })
      }

      reader.readAsDataURL(target.files[0])
    }
  }

  onChangeHeight(event, index, value) {
    this.setState({ height: value});
  }

  onProgramsShow(){
    if(this.state.programsShow){
      this.setState({ programsShow: false});
    } else {
      this.setState({ programsShow: true});
    }
  }
  selectWorkTeam(item){
    console.log(item)
    console.log('itemmmm')
    this.setState({
      workTeam: item.value
    })
  }

  render() {
    const { error, valid, handleSubmit, isBabyFeeding, bodyMeasure, setCheckIns,toggleForm,
      dispatch, onSubmit, initialValues, userInfo, profileData, profileFields, prevSeasons} = this.props
    let { firstName, lastName, email, gender, enabledSocialNetworks, workTeamNames, workTeamMembers } = userInfo.data
    const { injuryItems, diseases } = profileFields
    let fullNameItems, passportItems, birthdayIns
    const { programName } = profileData
    const isAlfa = domen.isAlfa
    const isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro
    let renderSmm = {}
    console.log('this.propsss')
    console.log(this.props)
    if(workTeamNames){
      workTeamNames = workTeamNames.map((item, idx) => {
        return  {
          label: item, value: item
        }
      })
    }
    if(enabledSocialNetworks && enabledSocialNetworks.length){
      enabledSocialNetworks.forEach((item, idx) => {
        renderSmm[item] = true
      })
    }
    console.log(renderSmm)

    if(profileData.insurance){
      fullNameItems = profileData.insurance.fullNameItems
      passportItems = profileData.insurance.passportItems
      birthdayIns = profileData.insurance.birthday
    }

    const sportsPast = [
      { text: 'Да', val: true, name:'yes' },
      { text: 'Нет', val: false, name:'no' }
    ]

    const injuriesExist = [
      { text: 'Есть', val: true, name:'yes2' },
      { text: 'Нет', val: false, name:'no2' }
    ]

    const childsItems =  [
      { text: '0', name:'zero'},
      { text: '1', name:'one'},
      { text: '2', name:'two' },
      { text: '>3', name:'third'}
    ]


    return (
      <div>
      <form className={styles.stageBoxBigPadding} onSubmit={handleSubmit(onSubmit)}>

        <div className={styles.stageBoxInner}>
          <h1 className={styles.h1}>Ваша анкета</h1>

          <p className={styles.baseParag}>Именно поэтому нашим тренерам необходимо знать состояние здоровья на данный момент.</p>
          <p className={styles.baseParag}>Данную анкету необходимо заполнить для Вашей же безопасности. Мы несем полную ответственность за результаты после выполнения всех составленных нами упражнениий.</p>
        </div>

        <hr className={styles.hr2}/>

        <div className={styles.stageBoxInner}>

          <h3 className={styles.h2}>Личные данные</h3>

          <div className={styles.grid}>
            <div className={styles.gridCell12Mb30}>
              <div className={styles.avatarWrap}>

                <div className={styles.avatarProfile}>

                  <label className={styles.avatarUpload} htmlFor="avatar">
                    <input id="avatar"
                           type="file"
                           ref="avaInput"
                           accept="image/*"
                           onChange={input => this.loadPhoto(input)}
                           className={styles.uploadFileInput}/>
                  </label>

                  <div className={styles.avatarImgWrap} onClick={() => {
                      this.refs.avaInput.click()
                  }}>
                    {!initialValues.photo ? <span className={styles.avatarText}>Загрузи фотографию</span> : null}
                    <img className={styles.avatarImg}
                         ref="avatar"
                         src={initialValues.photo ? initialValues.photo : (gender === 'male' ? '/assets/img/png/boy.png' : '/assets/img/png/girl.png')}
                         alt=""/>

                  </div>

                </div>

                {/*<p className={styles.mb20}><a href="#">Загрузить</a></p>*/}
                  <div>
                    <p className={styles.mb10}>Привязать социальную сеть:</p>
                    <ul className={styles.socialSignin}>
                      {renderSmm.FB && <li className={styles.socialSigninItemFb} onClick={() => {
                        FB.login(res => {
                          console.log('res')
                          console.log(res)
                          if (res.status === 'connected') {
                            FB.api(`/me`,{fields: 'picture'},
                              response => {
                              console.log('response')
                              console.log(response)
                                if (response.picture) {
                                  const photo = response.picture.data.url
                                  this.refs.avatar.src = photo
                                  const photoPayload = {
                                    authToken: cookie.load('token'),
                                    data: { photo }
                                  }
                                  this.updatePhoto(photoPayload)
                                  this.socialNetUserCreate(social.fb.id, res.authResponse.accessToken, 'FB')
                                }
                              }
                            )
                          }
                        })
                      }}>
                        <svg className={styles.svgIconFb}>
                          <use xlinkHref="#fb"></use>
                        </svg>
                      </li>}
                      { renderSmm.VK && <li className={styles.socialSigninItemVk} onClick={() => this.onclickVk()}>
                        <svg className={styles.svgIconVk}>
                          <use xlinkHref="#vk"></use>
                        </svg>
                      </li>}
                      { renderSmm.OK &&<li className={styles.socialSigninItemOk} onClick={() => {
                        const self = this

                        let config = {
                          app_id: social.ok.app_id,
                          app_key: social.ok.app_key
                        }
                       /* let config = {
                          app_id: 1264846848,
                          app_key: 'CBAJAFGMEBABABABA'
                        }*/

                        OKSDK.init(config, function () {
                          OKSDK.REST.call('users.getCurrentUser', { fields: 'pic190x190' }, function (status, data, error) {
                            console.log('statusss')
                            console.log(status)
                            console.log(data)
                            console.log(error)
                            if (data && data.pic190x190) {
                              const photo = data.pic190x190
                              self.refs.avatar.src = photo
                              const photoPayload = {
                                authToken: cookie.load('token'),
                                data: { photo }
                              }
                              self.updatePhoto(photoPayload)
                              self.socialNetUserCreate(social.ok.id, data.uid, 'OK')
                            }
                          })
                        }, function (error) {
                        })
                      }}>
                        <svg className={styles.svgIconOk}>
                          <use xlinkHref="#odnoklassniki"></use>
                        </svg>
                      </li>}
                      { renderSmm.IN &&
                      <li
                        className={styles.socialSigninItemIn}
                        onClick={() => this.onClickIn()}
                      >
                        <svg className={styles.svgIconIn}>
                          <use xlinkHref="#insta"></use>
                        </svg>
                      </li>}
                      {renderSmm.GP &&
                        <li
                          className={styles.socialSigninItemGp}
                          onClick={() => this.onClickGoogle()}
                        >
                          <svg className={styles.svgIconGp}>
                            <use xlinkHref="#g_plus"></use>
                          </svg>
                        </li>}
                        <li><div id="vk_auth"></div></li>
                    </ul>
                  </div>
              </div>
            </div>

            <div className={styles.gridCell12}>

              <div data-tip data-for='firstName' className={styles.input}>
                <Field  notReq={firstName} disabled={firstName ? true : false} name="firstName" placeholder="Имя" component={InputProfile} />
                { firstName ?<ReactTooltip id='firstName'>
                  <p>Для изменения обратитесь</p>
                  <p>в службу поддержки!</p>
                </ReactTooltip> : null}
              </div>

              <div data-tip data-for='lastName' className={styles.input}>
                <Field  notReq={lastName} disabled={lastName ? true : false} name="lastName" placeholder="Фамилия" component={InputProfile} />
                {lastName ?<ReactTooltip id='lastName'>
                  <p>Для изменения обратитесь</p>
                  <p>в службу поддержки!</p>
                </ReactTooltip> : null}
              </div>

              <div data-tip data-for='birthday' className={styles.input}>
                {window.mobileAndTabletcheck()
                  ? <Field name="birthday"
                          /* notReq={profileData.isFirstEdit  && profileData.birthday}*/
                           value={profileData.birthday}
                           /*disabled={profileData.isFirstEdit  && profileData.birthday ? true : false}*/
                           placeholder="дд-мм-гггг"
                           component={MobileDayPicker} />
                  : <Field name="birthday"
                           value={profileData.birthday}
                          /* notReq={profileData.isFirstEdit  && profileData.birthday}*/
                           /*disabled={profileData.isFirstEdit  && profileData.birthday ? true : false}*/
                           placeholder="дд-мм-гггг"
                           component={InputDayPicker} />
                }
                {profileData.isFirstEdit  && profileData.birthday ?<ReactTooltip id='birthday'>
                      <p>Для изменения обратитесь</p>
                      <p>в службу поддержки!</p>
                  </ReactTooltip> : null}

              </div>

              <div className={styles.staticField}>
                <div className={styles.staticFieldName}>Программа текущего сезона: </div>
                <div onClick={this.onProgramsShow.bind(this)} className={styles.staticFieldValueProgram}>{programName}</div>
                <svg className={styles.svgIconAccordion}>
                  <use xlinkHref="#ico-arrow-accordion"></use>
                </svg>
                <div className={this.state.programsShow ? styles.staticFieldProgram : styles.staticFieldProgramHide}>
                  {prevSeasons.map(item => {
                    return (
                      <div key={item.id} className={styles.staticFieldProgramLine}>
                        <div className={styles.staticFieldProgramItem}>
                          <span>Сезон: </span>
                          <span>{item.season}</span>
                        </div>
                        <div className={styles.staticFieldProgramItem60}>{item.name}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
              {/* {initialValues.program !== 2 &&
                <div>
                  <label className={styles.label}>
                    <p className={styles.labelTitle}>Ваш пол:</p>
                    <p className={styles.labelSubTitle}>Ответ обязательный</p>
                  </label>

                  < div className={styles.options}>
                    <Field name="gender"  value="male" type='radio' title="Мужчина" id="male" component={RadioProfile} />
                    <Field name="gender"  value="female" type='radio' title="Женщина" id="female" component={RadioProfile} />
                  </div>
                </div>
              }*/}
            </div>
          </div>

        </div>{/*stageBoxInner*/}

        <hr/>

        <div className={styles.stageBoxInner}>

          <h3 className={styles.h2}>Контактная информация</h3>

          <div className={styles.grid}>
            <div className={styles.gridCell12}>

              <div className={styles.input}>
                <Field name="country" id="country" placeholder='Страна' component={InputProfile} />
              </div>

              <div className={styles.input}>
                <Field name="city" placeholder='Город' component={InputProfile} />
              </div>

              <div className={styles.input}>
                <Field notReq={true} notice={true} name="street" placeholder='Улица' component={InputProfile} />
                <div data-tooltip="Адрес для доставки призов" className={styles.inputIco}>
                  <svg className={styles.svgIconFormHelp}>
                    <use xlinkHref="#ico-form-help"></use>
                  </svg>
                </div>
              </div>

                { isAlfa ?
              <div  className={styles.input}>
                <Field  name="workPosition" placeholder="Должность" component={InputProfile} />
              </div>
                  :null }

              <div className="select">
                <Field name="timezone" zone={new Date().getTimezoneOffset()} options={[
              { name: 'Самоаское время UTC−11', value: -11 },
              { name: 'Гавайско-Алеутское время UTC−10', value: -10 },
              { name: 'Аляскинское время UTC−9', value: -9 },
              { name: 'Тихоокеанское время UTC-8', value: -8 },
              { name: 'Горное время UTC−7', value: -7 },
              { name: 'Центральноамериканское время UTC−6', value: -6 },
              { name: 'Североамериканское восточное время UTC−5', value: -5 },
              { name: 'Атлантическое время UTC-4', value: -4 },
              { name: 'Аргентинское время UTC-3', value: -3 },
              { name: 'Азорские острова', value: -1 },
              { name: 'Среднее время по Гринвичу UTC', value: 0 },
              { name: 'Центральноевропейское время UTC+1', value: 1 },
              { name: 'Калининград UTC+2', value: 2 },
              { name: 'Московское время UTC+3', value: 3 },
              { name: 'Ижевск, Самара UTC+4', value: 4 },
              { name: 'Екатеринбург UTC+5', value: 5 },
              { name: 'Новосибирск UTC+6', value: 6 },
              { name: 'Красноярск UTC+7', value: 7 },
              { name: 'Иркутск UTC+8', value: 8 },
              { name: 'Якустк UTC+9', value: 9 },
              { name: 'Владивосток UTC+10', value: 10 },
              { name: 'Соломоновы острова UTC+11', value: 11 }
            ]} component={SelectProgram} />
                <svg className={styles.svgIconAccordion}>
                  <use xlinkHref="#ico-arrow-accordion"></use>
                </svg>
              </div>



            </div>

            <div className={styles.gridCell12}>

              <div className={styles.input}>
                <Field notReq={true} notice={true} name="instagram" placeholder="Ссылка на Instagram" component={InputProfile} />
                <div data-tooltip="Данное поле не обязательно для заполнения" className={styles.inputIco}>
                  <svg className={styles.svgIconFormHelp}>
                    <use xlinkHref="#ico-form-help"></use>
                  </svg>
                </div>
              </div>


              <div data-tip data-for='email' className={styles.input}>
                <Field notReq={email} disabled={email ? true : false} name="email" type="email" placeholder="Ваш email" defaultValue="anna@gmail.com" component={InputProfile} />
                {email ? <ReactTooltip id='email'>
                  <p>Для изменения обратитесь</p>
                  <p>в службу поддержки!</p>
                </ReactTooltip> :null}
              </div>


              <div className={styles.input}>{/*inputBtn*/}
                <div className={styles.inputFieldWrap}>
                  <Field name="phone" notice={true} type="tel" placeholder="Моб. телефон" component={InputProfile} />
                   <div data-tooltip="Например:<br>+7 xxx xxx xx xx" className={styles.inputIco}>
                      <svg className={styles.svgIconFormHelp}>
                        <use xlinkHref="#ico-form-help"></use>
                      </svg>
                    </div>

                </div>
              </div>

              <div className={styles.input}>
                <Field
                  name="workTeam"
                  type="text"
                  notice={true}
                  notReq={true}
                  placeholder="Ваша команда"
                  component={InputProfile}
                />
                <div data-tooltip="Это поле заполняется, если вы участвуете в составе команды из 5 участников" className={styles.inputIco}>
                  <svg className={styles.svgIconFormHelp}>
                    <use xlinkHref="#ico-form-help"></use>
                  </svg>
                </div>
              </div>

            </div>

          </div>


        </div>{/*stageBoxInner*/}

        <hr/>

        <div className={styles.stageBoxInner}>

          <h3 className={styles.h2}>Команда</h3>

          <div className={styles.grid}>
            <div className={styles.gridCell12}>
              <div className={styles.input}>
                <Field
                  name="workTeam"
                  type="text"
                  notice={true}
                  notReq={true}
                  val={this.state.workTeam}
                  placeholder="Ваша команда"
                  component={InputProfile}
                />
                <div data-tooltip="Это поле заполняется, если вы участвуете в составе команды из 5 участников" className={styles.inputIco}>
                  <svg className={styles.svgIconFormHelp}>
                    <use xlinkHref="#ico-form-help"></use>
                  </svg>
                </div>
                {workTeamNames &&
                  <Field
                    name='workTeamSelect'
                    placeholder='Выберите команду'
                    val={this.state.workTeam}
                    selectWorkTeam={this.selectWorkTeam.bind(this)}
                    options={workTeamNames}
                    component={SelectComponent}
                  />
                }
              </div>
            </div>

            <div className={styles.gridCell12}>
              {workTeamMembers ? <div className={styles.blockTeam}>
                <div className={styles.blockTeamTitle}>Состав команды:</div>
                <div className={styles.blockTeamList}>
                  {
                    workTeamMembers.map((item, idx) => {
                      return (
                        <div key={'member-'+idx} className={styles.blockTeamItem}>
                          {item.firstName} {item.lastName}
                        </div>
                      )
                    })
                  }
                </div>
              </div>: null }
            </div>
          </div>
        </div>

        <hr/>

        {initialValues.program % 4 === 2 &&
        <div className={styles.stageBoxInner}>

          <h3 className={styles.h2}>Дети</h3>

          <div className={styles.grid}>
            <div className={styles.gridCell12}>

              <label htmlFor="children[1]" className={styles.label}>Дата рождения последнего ребёнка</label>
              <div className={styles.input}>
                {window.mobileAndTabletcheck()
                  ? <Field  value={profileData.babyBirthday} name="babyBirthday" placeholder="дд-мм-гггг" component={MobileDayPicker} />
                  : <Field  value={profileData.babyBirthday} name="babyBirthday" placeholder="дд-мм-гггг" component={InputDayPicker} />
                }
              </div>

              <p className={styles.label}>Сколько у вас детей?</p>
              <ul className={styles.options}>
                {childsItems.map((item, index) => {
                  return (<li key={index} className={styles.optionsItemRadio}>
                    <input type="radio"
                           name='childs'
                           className={styles.optionsRadioInput}
                           value={item.name}
                           id={item.name}
                           checked={profileFields.babyCount === item.name}
                           onChange={() => {

                            dispatch({ type: 'CHILDS_SET', value: item.name })
                      }}/>
                    <label className={profileFields.babyCount === item.name ? styles.optionsItemNumbersActive : styles.optionsItemNumbers}
                           htmlFor={item.name}> {item.text}</label>
                  </li>)
                })}
              </ul>

            </div>


            <div className={styles.gridCell12}>

              <label htmlFor="children[2]" className={styles.label}>Месяц когда перестали кормить грудью</label>

              <div className={styles.grid}>
                <div className={styles.gridCell12}>
                  <div className={styles.checkboxMb10Mt10 }>
                    <label className={styles.checkboxLabel} htmlFor='isBabyFeeding'>
                      <Field name='isBabyFeeding'
                             id="isBabyFeeding"
                             className={styles.checkboxField}
                             component={CheckboxProfile}
                             checker = {isBabyFeeding}
                             title='Я еще кормлю'
                             type="checkbox"
                             onChange={() =>{
                            dispatch({ type: 'IS_BABY_FEEDING', isBabyFeeding: !isBabyFeeding })
                            dispatch({ type: 'LAST_BABY_FEED', lastBabyFeedMonth:''})
                            }
                          }/>

                    </label>
                  </div>
                </div>
                <div className={styles.gridCell12}>
                  <div className={styles.input}>
                    {window.mobileAndTabletcheck()
                      ? <Field   value={ profileData.lastBabyFeedMonth } disable={isBabyFeeding} name="lastBabyFeedMonth" placeholder="дд-мм-гггг" component={MobileDayPicker} />
                      : <Field   value={ profileData.lastBabyFeedMonth } disable={isBabyFeeding} name="lastBabyFeedMonth" placeholder="дд-мм-гггг" component={InputDayPicker} />
                    }
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>}

        {initialValues.program % 4 === 2 &&<hr/>}
        <div className={styles.stageBoxInner}>

          <h3 className={styles.h2}>Здоровье</h3>

          <p className={styles.baseParag}>Для того, чтобы добиться быстрых и качественных результатов тренеру важно знать некоторые особенности твоего организма. Это поможет ему правильно распределить нагрузкуна мышцы и организовать последовательность тренировок, не навредив твоему организму.</p>

          <p className={styles.baseParag}>Посчитай сколько раз ты <a href="#">приседаешь</a> за 1 минуту и запиши цифру!</p>

          <div className={styles.gridMt30}>
            <div className={styles.gridCell12}>
              <Timer timer={{
              minutes: 1,
              seconds: 5
            }}/>
            </div>

            <div className={styles.gridCell12}>
              <div className={styles.input}>
                <div className={styles.inputFieldWrap}>
                  <Field name="squatsCount" placeholder="Результат (ко-во)" component={InputCountMask} />
                </div>
                {/*    <div className="btn btn--base">Сохранить</div>*/}
              </div>
            </div>
          </div>

        </div>

        <hr/>

        <div className={styles.stageBoxInner}>

          <div className={styles.grid}>
            <div className={styles.gridCell12}>

              <label className={styles.label}>
                <p className={styles.labelTitle}>Занимался спортом раньше?</p>
                <p className={styles.labelSubTitle}>Пожалуйста, ваш ответ очень важен для нас</p>
              </label>

              <ul className={styles.options}>
                {sportsPast.map((item, index) => (
                  <li key={index} className={styles.optionsItemRadio48}>
                  <input type="radio"
                      name='didSports'
                      className={styles.optionsRadioInput}
                      id={item.name}
                      value={item.name}
                      checked={profileFields.didSports === item.val}
                      onChange={() => {
                        dispatch({ type: 'IS_SPORTS', didSports: item.val})
                      }}/>
                  <label className={profileFields.didSports === item.val ? styles.optionsItemActive : styles.optionsItem}
                          htmlFor={item.name}> {item.text}
                  </label>
                  </li>

                ))}
              </ul>

            </div>

            <div className={styles.gridCell12}>

              <label className={styles.label}>
                <p className={styles.labelTitle}>Есть травмы или проблемные зоны?</p>
                <p className={styles.labelSubTitle}>Ответ обязательный</p>
              </label>

              <ul className={styles.options}>
                {injuriesExist.map((item, index) => (
                  <li key={index} className={styles.optionsItemRadio48}>
                    <input type="radio"
                           name='injuriesExist'
                           className={styles.optionsRadioInput}
                           id={item.name}
                           value={item.name}
                           checked={profileFields.injuriesExist === item.val}
                           onChange={() => {
                        dispatch({ type: 'IS_INJURIES', injuriesExist: item.val})
                      }}/>
                    <label className={profileFields.injuriesExist === item.val ? styles.optionsItemActive : styles.optionsItem}
                           htmlFor={item.name}> {item.text}
                    </label>
                  </li>

                ))}
              </ul>


              {profileFields.injuriesExist ?
              <div className={styles.grid}>
                <div className={styles.gridCell12}>
                  <ul className={styles.checkboxes}>
                    <li className={styles.checkboxesItem}>
                          <span className={styles.checkbox}>
                              <label className={styles.checkboxLabel} htmlFor='neck'>
                                <Field className="checkbox__field"
                                       name='neck'
                                       id='neck'
                                       value = {injuryItems.neck}
                                       checker = {injuryItems.neck}
                                       component={CheckboxProfile}
                                       title='Шея и плечи'
                                       onChange={() =>{
                                         injuryItems['neck'] = !injuryItems['neck']
                                         dispatch({ type: 'INJURIES_GET', items: injuryItems })
                                      }}
                               />
                              </label>
                          </span>
                      </li>
                    <li className={styles.checkboxesItem}>
                          <span className={styles.checkbox}>
                              <label className={styles.checkboxLabel} htmlFor='hands'>
                                <Field className="checkbox__field"
                                       name='hands'
                                       id='hands'
                                       value = {injuryItems.hands}
                                       checker = {injuryItems.hands}
                                       component={CheckboxProfile}
                                       title='Руки'
                                       onChange={() =>{
                                         injuryItems['hands'] = !injuryItems['hands']
                                         dispatch({ type: 'INJURIES_GET', items: injuryItems })
                                      }}
                                />
                              </label>
                          </span>
                    </li>



                  </ul>
                </div>
                <div className={styles.gridCell12}>
                  <ul className={styles.checkboxes}>
                    <li className={styles.checkboxesItem}>
                          <span className={styles.checkbox}>
                              <label className={styles.checkboxLabel} htmlFor='back'>
                                <Field className="checkbox__field"
                                       name='back'
                                       id='back'
                                       value = {injuryItems.back}
                                       checker = {injuryItems.back}
                                       component={CheckboxProfile}
                                       title='Спина'
                                       onChange={() =>{
                                         injuryItems['back'] = !injuryItems['back']
                                         dispatch({ type: 'INJURIES_GET', items: injuryItems })
                                      }}
                                />
                              </label>
                          </span>
                    </li>
                    <li className={styles.checkboxesItem}>
                          <span className={styles.checkbox}>
                              <label className={styles.checkboxLabel} htmlFor='knees'>
                                <Field className="checkbox__field"
                                       name='knees'
                                       id='knees'
                                       value = {injuryItems.knees}
                                       checker= {injuryItems.knees}
                                       component={CheckboxProfile}
                                       title='Колени'
                                       onChange={() =>{
                                         injuryItems['knees'] = !injuryItems['knees']
                                         dispatch({ type: 'INJURIES_GET', items: injuryItems })
                                      }}
                                />
                              </label>
                          </span>
                    </li>
                  </ul>
                </div>
              </div>
                : null}

              {profileFields.injuriesExist ?
                  <div className={styles.textareaMt20}>
                    <textarea className={styles.textareaField}
                              defaultValue={diseases}
                              onChange={(event) =>{
                                dispatch({ type: 'DISEASES_SET', diseases: event.target.value })
                              }}
                              placeholder="Дополнительная информация о травмах/проблемных зонах">


                    </textarea>
                  </div>
                : null}

            </div>

          </div>


          <div className={styles.profileBtnsSave}>
            {/* <span className="btn btn--base">Cохранить, но не отправлять</span>*/}
            <button type='submit' className={styles.btnPrimaryCenter} onClick={() => {
              console.log('clickkk')
                if (!valid) {
                  console.log('!valid')
                  this.refs.submitFailModal.show()
                }
              }}>
              Отправить анкету
            </button>
          </div>

        </div>
      </form>

        <BodyParams bodyMeasure={bodyMeasure}/>

        {!isAlfa ?
        <Insurance docs={initialValues.insuranceFile}
                                 profileData={profileData}
                                 initialValues={{

                                    ...fullNameItems,
                                    ...passportItems,
                                     birthday:birthdayIns,
                                     passport:profileData.passport
                                 }}
                                 onSubmitAction={ data => {
                                   toggleForm(false)
                                   setCheckIns(true)
                                         const payload = {
                                            authToken: cookie.load('token'),
                                            data: {
                                                fullNameItems:{
                                                  firstName:data.firstName,
                                                  lastName:data.lastName,
                                                  middleName:data.middleName
                                                },
                                                passportItems:{
                                                  city:data.city,
                                                  issueCode:data.issueCode,
                                                  issueDate:data.issueDate,
                                                  issuePlace:data.issuePlace,
                                                  number:data.number

                                                },
                                                birthday:data.birthday,
                                                passport: data.passport,
                                                dateStart: '2016-05-29',
                                                dateEnd: '2016-11-29',
                                                amount: 100000
                                                //isActive: false
                                            }
                                          }
                                    return fetch(`${api}/user/insurance-create`, {
                                      headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                      },
                                      method: 'POST',
                                      body: JSON.stringify(payload)
                                    })
                                    .then(response => response.json())
                                    .then(json => {
                                        if (json.errorCode === 1 && json.data ){
                                          this.refs.successModal.show()
                                        } else {
                                          this.refs.failModal.show()
                                        }
                                      })
                                }}/>
          : null
        }

        <Modal ref='loadingModal' contentStyle={contentStyle} backdrop={false}>
          <div className={styles.entryHeader}>
            <h2 className={styles.entryTitleCenter}>Загружается...</h2>
          </div>
          <div className={styles.textCenter}>
            <div className={styles.loaderMain}></div>
          </div>
        </Modal>
        <Modal ref='failValidationModal' contentStyle={contentStyle}>
          <h2>Данные могут содержать только цифры с точкой</h2>
          <br/>
          <div className={styles.btnAction} onClick={() => this.refs.failValidationModal.hide()}>
            Продолжить
          </div>
        </Modal>
        <Modal ref='failValidationEmptyModal' contentStyle={contentStyle}>
          <h2>Некоторые данные не заполнены!</h2>
          <br/>
          <div className={styles.btnAction} onClick={() => this.refs.failValidationEmptyModal.hide()}>
            Продолжить
          </div>
        </Modal>
        <Modal ref='failModal' contentStyle={contentStyle}>
          <h2>Что-то пошло не так, поробуйте снова</h2>
          <br/>
          <div className={styles.btnAction} onClick={() => this.refs.failModal.hide()}>
            Продолжить
          </div>
        </Modal>
        <Modal ref='submitFailModal' contentStyle={contentStyle}>
          <h2>Одно или несколько полей были заполнены не правильно, проверьте вашу анкету еще раз</h2>
          <br/>
          <div className={styles.btnAction} onClick={() => this.refs.submitFailModal.hide()}>
            Продолжить
          </div>
        </Modal>
        <Modal ref='successModal' contentStyle={contentStyle}>
          <h2>Данные добавлены!</h2>
          <br/>
          <div className={styles.btnAction} onClick={() => this.refs.successModal.hide()}>
            Продолжить
          </div>
        </Modal>

      </div>
    )
  }
}

const validate = data => {
  const errors = {}
  data.firstName.replace(/ /g, '')
  data.lastName.replace(/ /g, '')

  switch (true) {
    case !data.firstName:
      errors.firstName = 'Имя должно быть заполнено'
      break
    case data.firstName.length < 3:
      errors.firstName = 'Имя должно быть длиннее 3 символов'
      break
    case data.firstName.length > 1000:
      errors.firstName = 'Имя должно быть короче 1000 символов'
      break
    // case !/^[A-Za-z0-9А-Яа-я]{3,20}$/.test(data.firstName):
    //   errors.firstName = 'Имя может содержать только буквы английского/русского алфавитов и цифры'
    //   break
    default:
      break
  }

  switch (true) {
    case !data.lastName:
      errors.lastName = 'Фамилия должна быть заполнена'
      break
    case data.lastName.length < 3:
      errors.lastName = 'Фамилия должна быть длиннее 3 символов'
      break
    case data.lastName.length > 1000:
      errors.lastName = 'Фамилия должна быть короче 1000 символов'
      break
    default:
      break
  }

  if (!data.gender) {
    errors.gender = ' (Пол должен быть заполнен)'
  }

  if (!data.country) {
    errors.country = 'Поле страны должно быть заполнено'
  }

  if (!data.city) {
    errors.city = 'Город должнен быть заполнен'
  }

  switch (true) {
    case !data.phone:
      errors.phone = 'Поле телефона должно быть заполнено'
      break
    case data.phone.length < 6:
      errors.phone = 'Поле телефона должно быть длиннее 3 символов'
      break
    case data.phone.length > 30:
      errors.phone = 'Поле телефона должно быть короче 30 символов'
      break
    case !/^[+\s0-9]{6,20}$/.test(data.phone):
      errors.phone = 'Поле должно содержать только цифры, знак +'
      break
    default:
      break
  }

  switch (true) {
    case !data.email:
      errors.email = 'Email должен быть заполнен'
      break
    case !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(data.email):
      errors.email = 'Email заполнен неправильно, проверьте его еще раз'
      break
    default:
      break
  }

  if(moment().diff(moment(data.birthday), 'years') < 18){
    errors.birthday = 'До 18 лет участие в марафоне запрещено'
  }

  if (!data.birthday) {
    errors.birthday = 'Поле должно быть заполнено'
  }

  if (!data.babyBirthday) {
    errors.babyBirthday = 'Поле должно быть заполнено'
  }

  if (!data.lastBabyFeedMonth) {
    errors.lastBabyFeedMonth = 'Поле должно быть заполнено'
  }

  if (!data.squatsCount) {
    errors.squatsCount = 'Количество приседаний должно быть заполнено'
  }

  if (data.didSports === undefined) {
    errors.didSports = 'Поле спорт должно быть отмечено'
  }

  if (data.injuriesExist === undefined) {
    errors.injuriesExist = 'Поле травмы должно быть отмечено'
  }

  // if (!data.diseasesExist) {
  //   errors.diseasesExist = 'Поле хронические заболевания должно быть отмечено'
  // } else if (data.diseasesExist && data.diseases.length === 0 && !data.diseasesAnother) {
  //   errors.diseases = 'Выберите хронические заболевания'
  // }

  // if (!data.pressure) {
  //   errors.pressure = 'Поле давление должно быть отмечено'
  // }
  //
  // if (!data.badHabbitsExist) {
  //   errors.badHabbitsExist = 'Поле вредные привычки должно быть отмечено'
  // }

  return errors
}

SubmitValidationForm = reduxForm({
  form: 'submitValidation',
  validate
})(SubmitValidationForm)

const mapDispatchToProps = dispatch => ({
  setCheckIns: bindActionCreators(actions.setCheckIns, dispatch),
  toggleForm: bindActionCreators(actions.toggleForm, dispatch),
  dispatch
})

const mapStateToProps = state => {
  const { bodyParams, injuriesHidden, profileFields, selectedTaskDay, sportsPast, isBabyFeeding, userInfo, sign } = state

  return {
    bodyParams,
    sign,
    injuriesHidden,
    sportsPast,
    selectedTaskDay,
    profileFields,
    isBabyFeeding,
    userInfo
  }
}

SubmitValidationForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitValidationForm)

export default CSSModules(SubmitValidationForm, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/profile/SubmitValidationForm.js